import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'components';
import { useHistoricLog } from 'apollo/filter-flowrates';
import HistoricLogGraph from './graph';
import { Filters } from './filters';

const stateName = 'waterQuality.filterFlowrates.graphicLog';

export function HistoricLog() {
  const [threshold, setThreshold] = useState({});
  const [yValuesMax, setYValuesMax] = useState(0);
  const { data, loading } = useHistoricLog();
  const { dataPoints } = useSelector(({ customers: { data } }) => data);
  const {
    waterQuality: {
      filterFlowrates: {
        graphicLog: { dataPoint },
      },
    },
  } = useSelector(({ state }) => state);
  useEffect(() => {
    if (dataPoint) {
      const data = dataPoints.find((key) => {
        return key._id === dataPoint;
      });
      setThreshold(data.setting.flowrates.threshold);
      setYValuesMax(data.setting.flowrates.yValuesMax);
    }
  }, [dataPoint, dataPoints]);

  return (
    <Container>
      <Filters stateName={stateName} />
      <HistoricLogGraph
        data={data}
        loading={loading}
        threshold={threshold}
        yValuesMax={yValuesMax}
      />
    </Container>
  );
}
